import {
  BattensEntity,
  CornersEntity,
  CrossPieceEntity,
  DoorsEntity,
  PanesEntity,
  PlatesEntity,
} from '../Data';
import { Color } from '../entities/Color';
import { Batten } from '../pieces/Batten';
import { Corner } from '../pieces/Corner';
import { CrossPiece } from '../pieces/CrossPiece';
import { Door } from '../pieces/Door';
import { Plate } from '../pieces/Plate';
import { Pane } from '../pieces/Pane';
import { PiecesList } from '../entities/PiecesList';
import colorsData from '../tests/fixtures/colors.json';
import piecesJSON from '../tests/fixtures/pieces.json';
import piecesPropertiesJSON from '../tests/fixtures/piecesProperties.json';

export class DataStorage {
  static pieces: PiecesList;
  static colors: Color[] = [];
  static piecesProperties: any = piecesPropertiesJSON;
}

function revivePieces(key: string, value: any) {
  switch (key) {
    case 'battens':
      return (value as BattensEntity[]).map(item => Batten.fromJSON(item));
    case 'corners':
      return (value as CornersEntity[]).map(item => Corner.fromJSON(item));
    case 'crossPieces':
      return (value as CrossPieceEntity[]).map(item =>
        CrossPiece.fromJSON(item),
      );
    case 'panes':
      return (value as PanesEntity[]).map(item => Pane.fromJSON(item));
    case 'doors':
      return (value as DoorsEntity[]).map(item => Door.fromJSON(item));
    // case 'drawers':
    //   return (value as DrawersEntity[]).map(item => Drawer.fromJSON(item));
    case 'plates':
      return (value as PlatesEntity[]).map(item => Plate.fromJSON(item));
    default:
      return value;
  }
}

// export function loadLocalPieces(): Pieces | void {
//   const data = localStorage.getItem('piecesData');
//   if (data) return JSON.parse(data, revivePieces);
// }

export function getPiecesData(): PiecesList {
  return DataStorage.pieces;
}

export function setPiecesData(pieces: PiecesList) {
  DataStorage.pieces = pieces;
}

export function getColors(): Color[] {
  if (!DataStorage.colors || DataStorage.colors.length === 0)
    throw new Error('Colors must be loaded before call this function');
  return DataStorage.colors;
}

export function setColors(colors: Color[]): Color[] {
  DataStorage.colors = colors;
  return colors;
}

export function getPiecesProps(): any {
  return DataStorage.piecesProperties;
}

export function loadLocalColor(): Color[] {
  const data = localStorage.getItem('colors');
  if (data) return JSON.parse(data) as Color[];
  return [];
}

export function saveColor(colors: Color[]) {
  localStorage.setItem('colors', JSON.stringify(colors));
}

function reviveColors(key: string, value: any) {
  return key === ''
    ? (value as Color[]).map(item => Color.fromJSON(item))
    : value;
}

export function loadColorsFromJson(json: string) {
  /**
   * Convert JSON to Color[]
   * Save the colors Globally in DataStorage.colors
   * Save the colors in the localstorage
   */
  const colors: Color[] = JSON.parse(json, reviveColors);
  setColors(colors);
  saveColor(colors);
  return colors;
}

export function initializeData() {
  setColors(Color.setupColors(colorsData));
  new PiecesList(JSON.stringify(piecesJSON));
}
